import { render } from "./PayInCanceledDealsCheckDescription.vue?vue&type=template&id=58623fdd&ts=true"
import script from "./PayInCanceledDealsCheckDescription.vue?vue&type=script&lang=ts"
export * from "./PayInCanceledDealsCheckDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__